var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSalesShipmentManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-salesShipmentManagement"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-salesShipmentManagement",
    clipPath: "url(#clip-icon-salesShipmentManagement)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M957.595,539.21a.5.5,0,0,1-.03-.07,29.126,29.126,0,0,0-2.05-3.1l-3.66-4.82L842.335,387.01a27.991,27.991,0,0,0-25.24-10.9H692.715V250.89a88,88,0,0,0-88-88H151.675a88,88,0,0,0-88,88V709.11a28.005,28.005,0,0,0,28,28h53.61a124,124,0,0,0,248,0h236a124,124,0,0,0,248,0h55.04a28,28,0,0,0,28-28V551.28A27.9,27.9,0,0,0,957.595,539.21Zm-688.31,265.9a68.007,68.007,0,1,1,68-68A68.071,68.071,0,0,1,269.285,805.11Zm484,0a68.071,68.071,0,0,1-68-68c0-.33,0-.67.01-1a65.577,65.577,0,0,1,.71-8.81v-.01a67.311,67.311,0,0,1,6.71-21.07,68,68,0,1,1,60.57,98.89Zm-60.57-281.83V432.11h113.55l69.24,91.17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M957.565,539.14a29.126,29.126,0,0,0-2.05-3.1l-3.66-4.82A27.906,27.906,0,0,1,957.565,539.14Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSalesShipmentManagement);
export default __webpack_public_path__ + "static/media/icon-salesShipmentManagement.326fbe1bdf228670ef8f10092187d329.svg";
export { ForwardRef as ReactComponent };